export default __webpack_public_path__ + "static/playStone-ed119fcaf79cb8e7ef476ec77c724383.svg";